<aslib-title Text="Empenho" SubText=" " Icon="fa fas fa-tasks"></aslib-title>
<div class="fieldRow"></div>
<br>
<div class="form-row">
  <div class="col-md-4">
    <div class="form-inline">
      <label for="dataEnvioPed">Data de envio do PED:</label>
      <input class="form-control ml-3 mr-2 col-md-5" name="dataEnvioPed"
        (ngModelChange)="dataEnvioPed = $event"
        type="date" [ngModel]="dataEnvioPed">
      <button class="btn btn-primary" type="button" (click)="getArquivoPed()"><em
          class="fa fa-caret-right"></em></button>
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-inline">
      <label>Dados para geração do EMP:</label>
      <select class="form-control ml-3 mr-2 col-md-5" [(ngModel)]="arquivoPed">
        <option value="" disabled selected>Selecione...</option>
        <option *ngFor="let item of arquivosPed" [ngValue]="item.key">{{item.value}} </option>
      </select>
      <button type="button" class="btn btn-primary"  [disabled] = "habilitarCarregar" (click)="emitterArquivoPed(arquivoPed)">Carregar</button>
    </div>
  </div>

  <div class="col-md-2">
    <div class="form-inline">
       <button type="button" class="btn btn-outline-primary" (click)="openModalParametros(parametros)">Exibir
        Parâmetros</button>
      <ng-template #parametros>
        <gpa-param-pagamento [modoEdicao]="false"></gpa-param-pagamento>
      </ng-template>
    </div>
  </div>
</div>

<br>
<div class="card-block" *ngIf="showTabsNavigation">
  <ul class="nav nav-tabs" role="tablist">
    <li class="nav-item active"><a class="nav-link active" routerLinkActive="active"
        [routerLink]="['processado']"><strong>PEDs processados</strong></a></li>
    <li class="nav-item"><a class="nav-link" routerLinkActive="active" [routerLink]="['nao_processado']"><strong>PEDs
          não processados</strong></a></li>
  </ul>
  <div class="tab-content">
    <div class="tab-pane fade show active" role="tabpanel">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<br>



// WEBPACK FOOTER //
// ./src/app/pagamento/empenho/empenho.component.html